import { Component } from '@angular/core';

/**
 * Agent shell — route `tutors/:tutorId`. Renders the agent frame (Orbi
 * header, menu, close button) once around the router outlet, so clicking
 * through an agent's pages swaps only the content card instead of rebuilding
 * the whole frame and reloading its data on every click. The pages keep their
 * own `<app-tutor-menu>` wrapper, which turns into a pass-through in here
 * (`TutorMenuComponent.inline`).
 *
 * The route now has a component, so its children no longer inherit
 * `tutorId` (Angular's `emptyOnly` strategy): pages read it from
 * `route.parent`.
 */
@Component({
  selector: 'app-tutor-shell',
  template: `<app-tutor-menu><router-outlet></router-outlet></app-tutor-menu>`,
  styles: [':host { display: block; }'],
})
export class TutorShellComponent {}
